import React from "react";
import { NavLink, Link } from "react-router-dom";
import "../css/verticalnav.css";
import ReviewData from "../pages/ReviewData";


const VerticalNavigation = () => {
  

  return (
    // <div className="wrapper">
    <div className="sidebar text-light">
      <ul className="text-light">
        <li>
          <NavLink className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'text-light btn')} to="/reviewdata">
            Data Review
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'btn text-light ')} to="/data-description">
            Data Description
          </NavLink>
        </li>
        <li>
          <NavLink
            className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'btn text-light')}
            type="button"
            to="/data-preprocessing"
          >
            Data Preprocessing
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'btn text-light')} to="/data-vizualization">
            Data Visualization
          </NavLink>
        </li>
        <li>
          <NavLink className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'btn text-light')} to="/feature-enginerring">
            Feature Engineering
          </NavLink>
        </li>
        <li>
          <button className='btn text-light'>Model Selection</button>
          <ul>
            <li>
              <NavLink className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'btn text-light')} to="/regression">
                Regression
              </NavLink>
            </li>
            <li>
              <NavLink className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'btn text-light')} to="/classification">
                classification
              </NavLink>
            </li>
            {/* <li>
              <NavLink
                className="btn  sub-buttton-operation"
                to="/tsa"
              >
                Time Series Analysis
              </NavLink>
            </li>
            <li>
              <NavLink
                className="btn  sub-buttton-operation"
                to="/clustering"
              >
                Clustering
              </NavLink>
            </li> */}
          </ul>
        </li>
        <li>
          <NavLink className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'btn text-light')} to="/model-evaluation">
            Model Evaluation
          </NavLink>
        </li>
        {/* <li>
          <NavLink className={({ isActive }) => (isActive ? 'btn  activesidenav' : 'btn text-light')} to='/report'>
            Report
          </NavLink>
        </li> */}
      </ul>
    </div>

    // </div>
  );
};

export default VerticalNavigation;
